const initProductFiltersForm = () => {
    const form =  document.querySelector("#product-filters-form")

    if (!form) {return}

    form.querySelectorAll('input').forEach((input) => {
        input.addEventListener('change', (e) => {
            e.stopPropagation()
            form.submit()
        })
    })

    form.querySelectorAll('select').forEach((input) => {
        input.addEventListener('change', (e) => {
            e.stopPropagation()
            form.submit()
        })
    })
}

export default initProductFiltersForm